import dayjs from 'dayjs'
import { DATE_FORMAT } from 'constants/constants.ts'
import { useTranslation } from 'react-i18next'
import { HeadingProps } from './types.ts'
import styles from './Heading.module.scss'
import { Heading as DSHeading, LoadingSkeleton } from '@boltenergy-be/design-system'
import { useParams } from 'react-router'
import { formatAddress } from 'utils/user.ts'
import classNames from 'classnames'

const Heading = ({ isLoading, electricityContract, ...props }: HeadingProps) => {
  // i18n
  const { t } = useTranslation('billing')

  // URL Param
  const { id } = useParams<{ id: string }>()

  // Constants
  const isCurrentPeriod = id === 'current'
  const startDate = isCurrentPeriod ? props.currentBillingCycle?.settlement.startDate : props.previousBillingCycle?.startDate
  const endDate = isCurrentPeriod ? props.currentBillingCycle?.settlement.endDate : props.previousBillingCycle?.endDate

  return (
    <header className={styles.header}>
      <DSHeading as="h1" variant="h3" serif>
        {t(($) => (isCurrentPeriod ? $.billingCycle.heading.currentTitle : $.billingCycles.previous.title))}
      </DSHeading>

      {isLoading && !isCurrentPeriod ? (
        <LoadingSkeleton className={styles.loader} as="small">
          {t(($) => $.billingCycle.heading.cycle)} <LoadingSkeleton.Rectangle height={16} width={80} /> –{' '}
          <LoadingSkeleton.Rectangle height={16} width={80} />
        </LoadingSkeleton>
      ) : startDate && endDate ? (
        <small>
          {t(($) => $.billingCycle.heading.cycle)} {dayjs(startDate).format(DATE_FORMAT)} – {dayjs(endDate).format(DATE_FORMAT)}
        </small>
      ) : null}

      {electricityContract && !isCurrentPeriod && (
        <small className={classNames('truncate', styles.address)}>{formatAddress(electricityContract.deliveryPoint.address)}</small>
      )}
    </header>
  )
}

export default Heading
